var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { attrs: { cols: "12", lg: "3" } },
            [
              _c(
                "v-toolbar",
                {
                  attrs: {
                    color: "primary",
                    dense: "",
                    elevation: "0",
                    dark: ""
                  }
                },
                [_c("span", [_vm._v("Create")])]
              ),
              _c("create-herica-client")
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "12", lg: "9" } },
            [
              _c(
                "v-toolbar",
                {
                  attrs: {
                    color: "primary",
                    dense: "",
                    elevation: "0",
                    dark: ""
                  }
                },
                [_c("span", [_vm._v("List")])]
              ),
              _c("table-herica-client")
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }